export default {"src":"/_next/static/image/public/images/empty_services.eba90a0566ec6173c9f94cfe52353a41.svg","height":148,"width":130};